import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import { Button, Form, Modal, Table } from "antd";
import BaseCard from "../../components/card/BaseCard";
import { Icon } from "@iconify/react";
import FormItemInput from "../../components/form-item/form-item-input";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import ButtonIcon from "../../components/ButtonIcon";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { $api, type components } from "../../helper";
import { useNotify } from "../../helper/notify";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { useParams, useSearchParams } from "react-router";
import { tokenMock } from "../../helper/mock";
import { useForm } from "antd/es/form/Form";
import FilterSearch from "../../components/filter/FilterSearch";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";

export default function ConnectedCourse() {
  const [isOpen, setIsOpen] = useState(false);
  const [addConnectionCourse, setAddConnectionCourse] = useState(false);
  const notify = useNotify();
  const [form] = useForm();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const [id, setId] = useState("");
  const [formCourse, setFormCorse] = useState<{
    filter_type: string;
    branch_u_id: string;
    department_u_id: string;
    term_u_id: string;
    class_codes: string[];
  }>({
    filter_type: "1",
    branch_u_id: "",
    department_u_id: "",
    term_u_id: "",
    class_codes: [],
  });
  const { mutate, data } = $api.useMutation(
    "get",
    "/site-api/v1/class-code-form/",
  );
  const courseDetail = $api.useQuery("get", "/site-api/v1/course/");
  const connect = $api.useMutation("post", "/site-api/v1/class-code/");
  const getClassCode = $api.useQuery("get", "/site-api/v1/class-code/", {
    params: {
      query: {
        course_u_id: params.id ?? "",
      },
    },
  });
  const deleteClassCode = $api.useMutation(
    "delete",
    "/site-api/v1/class-code/",
  );
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("لیست دوره ها");
  }, []);

  useEffect(() => {
    mutate({
      params: {
        query: {
          course_type: Number(searchParams.get("type")),
          filter_type: Number(formCourse.filter_type),
          branch_u_id: formCourse.branch_u_id,
          department_u_id: searchParams.get("department_u_id") ?? "",
          term_u_id: formCourse.term_u_id,
        },
      },
      headers: {
        Authorization: tokenMock,
        lang: "fa",
      },
    });
  }, [formCourse]);

  const columns: TableProps<
    components["schemas"]["SiteClassCodeItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "عنوان دوره",
      dataIndex: "name",
      key: "name",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.name
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "کد کلاس",
      key: "class_code",
      dataIndex: "class_code",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.class_code
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "سطح",
      key: "level_name",
      dataIndex: "level_name",
    },
    {
      title: "شعبه",
      key: "branch_name",
      dataIndex: "branch_name",
    },
    {
      title: "ترم",
      key: "term_name",
      dataIndex: "term_name",
    },
    {
      title: "استاد",
      key: "teacher",
      dataIndex: "teacher",
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setIsOpen(true);
              setId(record.u_id);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setIsOpen(true);
              setId(record.u_id);
            }}
          />
        </div>
      ),
    },
  ];

  const onFinish = (values: { class_code_u_ids: string[] }) => {
    connect.mutate(
      {
        body: {
          class_code_u_ids: values.class_code_u_ids,
          course_u_id: params.id ?? "",
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      },
      {
        onSuccess: (data) => {
          notify.success(data.message);
          setAddConnectionCourse(false);
          form.resetFields();
          getClassCode.refetch();
        },
      },
    );
  };

  return (
    <div className="grid grid-cols-12 gap-6">
      {/* modal */}
      <ConfirmModal
        pending={deleteClassCode.isPending}
        title="حذف از دوره ها ؟"
        description="حذف این دوره باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() => {
          deleteClassCode.mutate(
            {
              params: {
                query: {
                  class_code_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                setIsOpen(false);
                setId("");
                getClassCode.refetch();
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => {
          setId("");
          setIsOpen(false);
        }}
      />
      <Modal
        open={addConnectionCourse}
        onCancel={() => {
          setAddConnectionCourse(false);
          form.resetFields();
          setFormCorse({
            filter_type: "1",
            branch_u_id: "",
            department_u_id: "",
            term_u_id: "",
            class_codes: [],
          });
        }}
        closeIcon={false}
        footer={false}
        title={"افزودن دوره"}
      >
        <Form
          onFinish={onFinish}
          form={form}
          className="flex flex-col mt-4 gap-3"
        >
          <FormItemInputSelect
            name={"branch_u_id"}
            layout="vertical"
            label={"شعبه ها"}
            inputProps={{
              onChange: (e) => {
                setFormCorse({
                  ...formCourse,
                  branch_u_id: e,
                  filter_type: "3",
                  department_u_id: searchParams.get("department_u_id") ?? "",
                });
                form.resetFields([
                  // "department_u_id",
                  "term_u_id",
                  "class_codes_u_ids",
                ]);
              },
              options: data?.data.branches_list?.map((e) => ({
                label: e.name,
                value: e.u_id,
              })),
            }}
          />
          {/* <FormItemInputSelect
            name={"department_u_id"}
            layout="vertical"
            label={"دپارتمان ها"}
            inputProps={{
              onChange: (e) => {
                setFormCorse({
                  ...formCourse,
                  department_u_id: e,
                  filter_type: "3",
                });
                form.resetFields(["term_u_id", "class_codes_u_ids"]);
              },
              options: data?.data.departments_list?.map((e) => ({
                label: e.name,
                value: e.u_id,
              })),
            }}
          /> */}
          <FormItemInputSelect
            name={"term_u_id"}
            layout="vertical"
            label={"ترم ها"}
            inputProps={{
              onChange: (e) => {
                setFormCorse({ ...formCourse, term_u_id: e, filter_type: "4" });
                form.resetFields(["class_code_u_ids"]);
              },
              options: data?.data.terms_list?.map((e) => ({
                label: e.name,
                value: e.u_id,
              })),
            }}
          />
          <FormItemInputSelect
            name={"class_code_u_ids"}
            layout="vertical"
            label={"دوره ها"}
            inputProps={{
              onChange: (e) => {
                setFormCorse({
                  ...formCourse,
                  class_codes: e,
                  filter_type: "4",
                });
              },
              mode: "multiple",
              options: data?.data.class_codes_list?.map((e) => ({
                label: `${e.class_code} <${e.name}>`,
                value: e.u_id,
              })),
            }}
          />
          <div className="flex gap-4 mt-4">
            <Button
              loading={connect.isPending}
              htmlType="submit"
              type="primary"
              className="w-1/2"
            >
              تایید
            </Button>
            <Button
              onClick={() => {
                setAddConnectionCourse(false);
                form.resetFields();
                setFormCorse({
                  filter_type: "1",
                  branch_u_id: "",
                  department_u_id: "",
                  term_u_id: "",
                  class_codes: [],
                });
              }}
              className="w-1/2"
              danger
            >
              لغو
            </Button>
          </div>
        </Form>
      </Modal>
      <div className="w-full flex justify-between col-span-full items-center">
        <CustomBreadcrumb
          items={[
            {
              title: "مدیریت دوره ها",
              href: "/courses",
            },
            {
              title: courseDetail.data?.data.find((e) => e.u_id === params.id)
                ?.title,
            },
          ]}
        />
        <Button onClick={() => setAddConnectionCourse(true)} type="primary">
          اتصال به دوره
        </Button>
      </div>

      <div className="w-full flex-1 col-span-full">
        <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
          <div className="w-full flex justify-between items-center">
            <div className="flex gap-6 items-center">
              <FormItemInput
                inputProps={{
                  placeholder: "جستجو دوره...",
                  prefix: (
                    <Icon
                      icon={"solar:minimalistic-magnifer-linear"}
                      className="text-xl"
                    />
                  ),
                }}
              />
            </div>
          </div>
          <BaseTable
            props={{
              className: "min-w-0!",
            }}
          >
            <Table<components["schemas"]["SiteClassCodeItem"]>
              scroll={{
                x: "max-content",
              }}
              columns={columns}
              dataSource={getClassCode?.data?.data}
              loading={getClassCode.isLoading}
            />
          </BaseTable>
        </BaseCard>
      </div>
    </div>
  );
}
